// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"67":"VodStats","82":"Setup","544":"slack-chat","559":"Videos","561":"Dashboard","944":"OptaStats"}[chunkId] || chunkId) + "." + chunkId + ".css";
};